<template>
<v-app>
  
  <div v-if="$store.state.account.token === null && $route.meta.required_login">
    {{ $router.push( "login" ) }}
  </div>
  <div v-if="this.$route.path != '/'">
  <v-navigation-drawer app v-model="drawer2" clipped v-if="superuser">
    <v-container>
      
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title grey--text text--darken-2">
            {{ $t( "app.adminlist" ) }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      
      <v-list dense>
        <v-list-item-group v-model="item" color="primary">
          <div v-for="(sideitem, i) in sideitems" :key="i">
            <v-subheader >{{$t( "app." + sideitem.name )}}</v-subheader>
            <v-list-item v-for="(content, j) in sideitem.contents" :key="j">
              <v-list-item-icon> <v-icon>{{ content.icon }}</v-icon> </v-list-item-icon>
              
              <v-list-item-content @click="hoge( i, j )"> <v-list-item-title>{{content.text}}</v-list-item-title> </v-list-item-content>
            </v-list-item>
          </div>
          
        </v-list-item-group>
      </v-list>
    </v-container>
  </v-navigation-drawer>
  </div>
  
  
  <v-app-bar color="teal lighten-3" dark app dense clipped-left v-if="this.$route.meta.header">
    <v-app-bar-nav-icon @click="drawer2=!drawer2" v-if="superuser"/>
    <v-toolbar-title @click="$router.push( 'calendar' )"> {{ $t("common.headertitle") }}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <v-btn text outlined to="/logout">{{$t("common.logout")}}</v-btn>
    </v-toolbar-items>
    
    <v-toolbar-items>
      <v-menu offset-y>
        <template v-slot:activator="{on}">
          <v-btn v-on="on" text outlined> {{ $t( "app.menu" ) }} <v-icon>mdi-menu-down</v-icon></v-btn>
        </template>
        <v-list>
          <v-list-item @click="$router.push( 'profile' )"><v-list-item-content><v-list-item-title>{{ $t( "app.profile" ) }}</v-list-item-title></v-list-item-content></v-list-item>
          <v-list-item @click="$router.push( 'calendar' )"><v-list-item-content><v-list-item-title>{{ $t( "app.calendar" ) }}</v-list-item-title></v-list-item-content></v-list-item>
          <v-list-item @click="$router.push( 'heatmap' )"><v-list-item-content><v-list-item-title>{{ $t( "app.heatmap" ) }}</v-list-item-title></v-list-item-content></v-list-item>
          <v-list-item @click="$router.push( 'contactus' )"><v-list-item-content><v-list-item-title>{{ $t( "app.contactus" ) }}</v-list-item-title></v-list-item-content></v-list-item>
        </v-list>
      </v-menu>
      
    </v-toolbar-items>
  </v-app-bar>
  
  <!-- Contents!! -->
  <v-content>
    <router-view @updateParent="handleUpdate" />
  </v-content>
  
  <!-- Footer setting -->
  <v-footer color="#dfb2b6" app padless >
    <v-row justify="start" no-gutters >
      <v-btn small color="white" text @click="$router.push('octopt')"> {{ $t( "footer.company" ) }} </v-btn>
      <v-btn small color="white" text @click="$router.push( 'termsofservice' )"> {{ $t( "footer.termsofuse" ) }} </v-btn>
      <v-btn small color="white" text @click="$router.push( 'privacypolicy' )"> {{ $t( "footer.pp" ) }} </v-btn>
      <v-btn small color="white" text @click="$router.push('contactus')"> {{ $t( "footer.contactus" ) }} </v-btn>
    </v-row>
    
    <v-row cols="3" justify="end">
      <v-col cols="1"><v-icon size="20px" @click="$router.push('twitter')">{{'mdi-twitter'}} </v-icon></v-col>
      <v-col cols="1"><v-icon size="20px" @click="$router.push('facebook')">{{'mdi-facebook'}} </v-icon></v-col>
      <v-col cols="1" class="mr-5"><v-icon size="20px" @click="$router.push('instagram')">{{'mdi-instagram'}} </v-icon></v-col>
    </v-row>
  </v-footer>
  
  <v-dialog v-model="privacy_policy" width="800px">
    <v-card>
      <v-card-title>
      </v-card-title>
      <v-card-text><PrivacyPolicy /></v-card-text>
    </v-card>
  </v-dialog>
  
  <v-dialog v-model="terms_of_service" width="800px">
    <v-card>
      <v-card-title>
      </v-card-title>
      <v-card-text><TermsOfService /></v-card-text>
    </v-card>
  </v-dialog>
  
  
</v-app>

</template>


<script>
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";

import gql from 'graphql-tag'
const QUERY1 = gql`query{
   getManageDepartments
   }`


export default {
    components: {PrivacyPolicy,
                TermsOfService},
    data(){
        return{
            terms_of_service: false,
            content: "",
            current_year: (new Date()).getFullYear(),
            drawer2: null,
            superuser: false,
            item: 3,
            privacy_policy: false,
            external: "",
            sideitems: [
                { name: 'department_items',
                  contents:[ 
                      { text: this.$t("app.adminsetting"), icon: 'mdi-hospital-building', url:'departmentsetting' },
                      { text: this.$t("app.adminrule"), icon: 'mdi-format-line-spacing', url: 'departmentrulesetting' },
                      { text: this.$t("app.team_setting"), icon: 'mdi-account-switch-outline', url: 'teamsetting' },
                  ]
                },
                {name: 'usermanage_items',
                 contents:[
                     { text: this.$t("app.adminusermanage"), icon: 'mdi-account-multiple-plus', url: 'usermanagement' },
                     { text: this.$t("app.adminuserpropmanage"), icon: 'mdi-account-star', url: 'userpropmanagement' },
                 ]
                },
                {name: 'scheduler_items',
                 contents: [
                     { text: this.$t("app.adminschedule"), icon: 'mdi-clock', url: 'heatmap' },
                 ]
                },
            ],
            nav_lists:[
                {
                    name: 'Getting Started',
                    icon: 'mdi-speedometer',
                    lists:['Quick Start','Pre-made layouts']
                },
                {
                    name: 'Customization',
                    icon: 'mdi-cogs' 
                },
                {
                    name: 'Styles & animations',
                    icon: 'mdi-palette',
                    lists:['Colors','Content','Display']
                },
                {
                    name: 'UI Components',
                    icon: 'mdi-view-dashboard',
                    lists:['API explorer','Alerts']
                },
                {
                    name: 'Directives',
                    icon: 'mdi-function'
                },
                {
                    name: 'Preminum themes',
                    icon: 'mdi-vuetify'
                },
            ]
        }
    },
    computed: {
    },
    apollo: {
        getManageDepartments:{
            query: QUERY1,
            fetchPolicy: 'cache-and-network',
            result({ data, loading, networkStatus }){
                if( !loading ){
                    console.log( "from App.vue" )
                    if( JSON.parse( data.getManageDepartments ).length ){
                        this.handleUpdate( true )
                    }else{
                        this.handleUpdate( false )
                    }
                }
                (data, networkStatus)
            },
        },        
    },
    created(){
        document.title = "AllShifter | シフトスケジュール"
    },
    mounted(){
        // this.readHtml();
        // this.getFileContent( "../assets/privacypolicy.html" )
        // alert( this.content )
        // alert( this.content )
        document.title = "AllShifter | シフトスケジュール"
    },
    
    methods: {
        handleUpdate: function (value) {
            this.superuser = value
        },        
        hoge( i, j ){
            this.$router.push( this.sideitems[ i ][ 'contents' ][ j ].url ) 
            // console.log( this.$router )
            // console.log( this.$route )
        },
        readHtml(){
            fetch("src/assets/privacypolicy.html").then(res => {
                res.text().then(html => { this.external = html; });  
            });
        },
        
        async getFileContent(file){
            try{
                const content = await this.readFileAsync(file)
                this.content = content
                alert( content )
            }catch (e){
                console.log(e)
            }
        },
        readFileAsync (file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.onload = () => {
                    resolve(reader.result)
                }
                reader.onerror = reject
                reader.readAsText(file)
            })
        }
    }
}
</script>
